import { Link } from "shared/components/Link";;
import { AppRoute } from "../../constants";
import IEC608705104Server from "../../images/systemComponents/IEC608705104Server.png";
import Layout from "../../components/Layout";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    МЭК 60870-5-104 (Сервер)
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        <b>Сервер МЭК 60870-5-104</b>  в SCADA NPT Compact обеспечивает передачу технологической информации с объекта автоматизации в диспетчерские центры (в ЦУС, в АО «СО ЕЭС») или другие автоматизированные системы (такие как <Link className="text-links" to={`/${AppRoute.IntegRPAMonitor}`}>АСМ РЗА</Link>  ) средствами телемеханики по протоколу МЭК 60870-5-104. Сбор данных осуществляется с помощью клиента МЭК 60870-5-104 или других промышленных протоколов обмена данными.
                    </p>
                    <img
                        src={IEC608705104Server}

                        className="mb-4  w-100"
                        alt="IEC608705104 Сервер"
                    />

                    <p>Передача данных с подстанции в диспетчерские центры по протоколу МЭК 60870-5-104 используется для обеспечения эффективного управления, мониторинга и контроля энергосистемы. Этот протокол является стандартом для телемеханических систем в энергетике и обеспечивает надежную связь между удаленными объектами (например, подстанциями) и центрами управления (диспетчерскими центрами). </p>
                    <p>
                        Основные цели передачи данных по протоколу МЭК 60870-5-104 включают:
                    </p>
                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li">Сбор данных о текущем состоянии оборудования подстанции, таких как:
                            <ul>
                                <li>Положение выключателей и разъединителей.</li>
                                <li>Состояние релейной защиты и автоматики.</li>
                                <li>Аварийные сигналы и предупреждения.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li">Сбор измеряемых параметров, таких как:
                            <ul>
                                <li>Напряжение, ток, активная и реактивная мощность.</li>
                                <li>Частота, уровень нагрузки, температура трансформаторов.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li">Передача команд от диспетчерского центра на подстанцию для:
                            <ul>
                                <li>Включения/выключения выключателей.</li>
                                <li>Изменения уставок релейной защиты.</li>
                                <li>Переключение режимов работы оборудования.   </li>
                            </ul>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </Layout>
}
export const meta = {
    title: 'МЭК 60870-5-104 (Сервер)',
    description: 'Сервер МЭК 60870-5-104 в SCADA NPT Compact обеспечивает передачу технологической информации с объекта автоматизации в диспетчерские центры (в ЦУС, в АО «СО ЕЭС») или другие автоматизированные системы (такие как АСМ РЗА) средствами телемеханики по протоколу МЭК 60870-5-104. Сбор данных осуществляется с помощью клиента МЭК 60870-5-104 или других промышленных протоколов обмена данными.'
}
//export const doNotPrerender = false;